import React from "react";

import { Pie } from "@ant-design/plots";
import { getCSSVariable } from "@Utils";
import { PieConfig } from "@ant-design/charts";
import { IProgressMetric } from "@Components/activity/hooks/useAssociatedStatuses";
import { PARTIAL_VISUALISATION_CONFIGURATION } from "@Components/shared/visualisationConstants";

interface IProps {
    progress: IProgressMetric;
}

interface IRingProgressPieChartData {
    type: string;
    value: number;
    activityTitle: string;
    activityValue: number;
}

interface IRingProgressChartTooltipItem {
    color: string;
    data: IRingProgressPieChartData;
    name: string;
    value: string;
}

const RingProgressPieChart = ({ progress }: IProps) => {
    const data: IRingProgressPieChartData[] = [
        {
            type: "Points Earned",
            value: progress.earned.points,
            activityTitle: "Activities",
            activityValue: progress.earned.activities,
        },
        {
            type: "Points available to earn on community activities",
            value: progress.total.points - progress.earned.points - progress.loggedInUserAvailable.points,
            activityTitle: "Activities",
            activityValue:
                progress.total.activities - progress.earned.activities - progress.loggedInUserAvailable.activities,
        },
        {
            type: "Points available to earn on your activities",
            value: progress.loggedInUserAvailable.points,
            activityTitle: "Activities",
            activityValue: progress.loggedInUserAvailable.activities,
        },
    ];

    const config: PieConfig = {
        ...PARTIAL_VISUALISATION_CONFIGURATION,
        appendPadding: 0,
        data,
        angleField: "value",
        colorField: "type",
        radius: 0.9,
        innerRadius: 0.85,
        color: [
            getCSSVariable("--inovus-blue"),
            getCSSVariable("--inovus-light-grey"),
            getCSSVariable("--keyline-dark-grey"),
        ],

        legend: false,
        pieStyle: {
            lineWidth: 0,
        },
        statistic: {
            content: {
                style: {
                    fontSize: "24px",
                    lineHeight: "32px",
                },
                formatter: () => String(progress.earned.points),
            },
            title: {
                style: {
                    color: "#363636",
                    fontSize: "16px",
                    lineHeight: "18px",
                },
                formatter: () => "Total Points Earned",
            },
        },
        tooltip: {
            customContent: (_title: string, items: IRingProgressChartTooltipItem[]) => {
                if (!items || items.length === 0) return "";
                const item = items[0];
                return `
                    <div style="padding: 8px; min-width: 160px;">
                        <div style="display: flex; justify-content: space-between;">
                            <div style="margin-bottom: 8px; font-weight: 600; color: ${item.color}">
                            ${item.data.type}
                            </div>
                            <span style="font-weight: 500; margin-left: 5px;">${item.data.value}</span>
                        </div>
                        <div style="display: flex; justify-content: space-between;">
                            <div style="margin-bottom: 8px; font-weight: 600; color: ${item.color}">
                            ${item.data.activityTitle}
                            </div>
                            <span style="font-weight: 500;">${item.data.activityValue}</span>
                        </div>
                    </div>
                `;
            },
        },
    };
    return <Pie {...config} />;
};

export default RingProgressPieChart;
